import { render, staticRenderFns } from "./ProductMarketplacesManager.vue?vue&type=template&id=2c13b838"
import script from "./ProductMarketplacesManager.vue?vue&type=script&lang=js"
export * from "./ProductMarketplacesManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports